import {Fragment} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconButton, useTheme} from "@mui/material";
import TableTooltip from "./TableTooltip";
import {Link} from "./widgets";
import {MessageDescriptor} from "react-intl";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

type Props = {
    shortcutPath: string; // Where to redirect the user
    tooltipTitle: MessageDescriptor; // Translation
    buttonIcon: IconProp; // Custom icon to use
    color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
    disabled?: {
        reason: MessageDescriptor; // Reason why the button is disabled
    };
};

/**
 * Shortcut action button for domain list table
 */
const TableShortcutButton: React.FC<Props> = ({
    shortcutPath,
    tooltipTitle,
    buttonIcon,
    color: _color = "primary",
    disabled,
}) => {
    const theme = useTheme();
    const disabledReason = disabled?.reason;

    const color = disabledReason ? theme.palette.action.disabled : theme.palette[_color].main;

    // the span is needed if the button is disabled to allow tooltip to work
    return (
        <Fragment>
            <TableTooltip tooltipTitle={disabledReason ?? tooltipTitle}>
                <span>
                    <IconButton size="small" disabled={disabledReason != null}>
                        <Link to={shortcutPath}>
                            <FontAwesomeIcon color={color} icon={buttonIcon} />
                        </Link>
                    </IconButton>
                </span>
            </TableTooltip>
        </Fragment>
    );
};

export default TableShortcutButton;
